import { Address } from './Address';
import { TableData } from './Table';

export interface Tenant extends TableData {
  id: string;
  name: string;
  isOcpiActive?: boolean;
  email: string;
  address: Address;
  subdomain: string;
  type: 'Normal' | 'Parent' | 'Child';
  parentID: string | null;
  components?: TenantComponent;
  logo: string;
  favicon: string;
  primaryColor: string;
  secondaryColor: string;
}

export interface TenantComponent {
  ocpi?: TenantComponentContent;
  oicp?: TenantComponentContent;
  organization?: TenantComponentContent;
  pricing?: TenantComponentContent;
  billing?: TenantComponentContent;
  billingPlatform?: TenantComponentContent;
  refund?: TenantComponentContent;
  statistics?: TenantComponentContent;
  analytics?: TenantComponentContent;
  smartCharging?: TenantComponentContent;
  asset?: TenantComponentContent;
  car?: TenantComponentContent;
  carConnector?: TenantComponentContent;
}

export interface TenantComponentContent {
  active: boolean;
  type: string;
}

export enum TenantButtonAction {
  EDIT_TENANT = 'edit_tenant',
  CREATE_TENANT = 'create_tenant',
  DELETE_TENANT = 'delete_tenant',
}

export enum TenantComponents {
  OCPI = 'ocpi',
  QRCODE = 'qr-code',
  OICP = 'oicp',
  REFUND = 'refund',
  PRICING = 'pricing',
  ORGANIZATION = 'organization',
  STATISTICS = 'statistics',
  ANALYTICS = 'analytics',
  BILLING = 'billing',
  BILLING_PLATFORM = 'billingPlatform',
  ASSET = 'asset',
  SMART_CHARGING = 'smartCharging',
  DOUBLE_ACCESS = 'doubleAccess',
  MULTIPLE_TARIFS = 'multipleTarifs',
  CAR = 'car',
  CAR_CONNECTOR = 'carConnector',
  CHARGING_STATION_TEMPLATE = 'chargingStationTemplate',
  BORNE_VIP = 'borneVIP',
  WALLET = 'wallet',
  DATAGOUV_STATIC_DATA = 'dataGouvStaticData',
  DATAGOUV_DYNAMIC_DATA = 'dataGouvDynamicData',
}
